/**
 * Evaluation result component.
 */

import './_result-evaluation.scss';
import { ApplicationContext } from '../../common/context';
import { FormattedMessage } from "react-intl";
import React, { useContext } from 'react';

const ResultEvaluate = () => {
  const context = useContext(ApplicationContext);
  const prefix = context.isMatrix ? 'matrix' : 'evaluation';
  const pathname = window.location.href;
  const langSplit = pathname.split('=');
  const language = langSplit.length > 1 && langSplit[1] == 'en' ? 'en' : 'pt';
  const totals = context.getOption(`${prefix}.totals`, null);
  const total = Object.keys(totals);

  const form = context.getOption(`${prefix}.form`, null);
  const allValues = [];

  const formatter = new Intl.NumberFormat('de-DE', {
    currency: 'EUR',
    minimumFractionDigits: 0,
    style: 'currency'
  });

  // eslint-disable-next-line no-unused-vars
  let maxValue = 0;

  const sortform = [...form];

  sortform.sort((a, b) => {
    return a[1] < b[1] ? -1 : 1;
  });

  form.map(item => {
    allValues.push(item[1]);
    maxValue = Math.max(...allValues);
  });

  const ballSize = value => {
    const minSize = 20;
    const maxSize = 200;
    const maxValue = Math.max(...allValues);

    const size = Math.round(value * maxSize / maxValue);

    if (size < minSize) {
      return minSize;
    }

    return parseInt(size, 10);
  };

  const calculatePosition = (value, pos) => {
    let position = 0;

    if (pos === 1) {
      position = value * 100 / 21;
    }
    if (pos === 2) {
      position = value * 100 / 18;
    }

    return parseFloat(position, 10).toFixed(2);
  };

  const ballZindex = value => {
    let zindex = 20;

    if (value > 20) {
      zindex = value * 126 / maxValue;

      if (zindex < 20) {
        zindex = 99999;
      }

      if (zindex === 126) {
        zindex = 0;
      }
    }

    return parseInt(zindex, 10);
  };

  return (
    <div className={'result'}>
      <div className={'page-form__header result__header'}>
        <div className={'page-form__header-left'}>
          <a href={'/'}>
            <img
              alt={'cotec - matriz'}
              src={'cotec-logo.svg'}
            />
          </a>

          <p className={'page-form__header__label'}> {'RISK CHECK'} </p>

          <p className={'page-form__header__title'}>
            <FormattedMessage id="evaluate.title"/>
          </p>
        </div>
      </div>

      <div className={'result__graphic-wrap'}>
        <div className={'result__graphic-overflow'}>
          <div className={language == 'pt' ? 'result__graphic' : 'result__graphic result__graphic--en'}>
            <div style={{
              height: '441px',
              marginLeft: 70,
              position: 'relative',
              top: '85px',
              width: '480px'
            }}
            >
              {total.map((item, index) => (

                <div
                  className={'result__graphic-bubble'}
                  key={index}
                  style={{
                    backgroundColor: 'rgba(119,119,119,0.85)',
                    borderRadius: '50%',
                    bottom: `${calculatePosition(totals[item][0], 2)}%`,
                    height: `${ballSize(form[item][1])}px`,
                    left: `${calculatePosition(totals[item][1], 1)}%`,
                    position: 'absolute',
                    transform: 'translate(-50%, 50%)',
                    width: `${ballSize(form[item][1])}px`,
                    zIndex: `${ballZindex(form[item][1])}`
                  }}
                >
                  <span
                    style={{
                      lineHeight: `${ballSize(form[item][1])}px`
                    }}
                  >
                    {String.fromCharCode('A'.charCodeAt() + index)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div>
          <div className={'result__graphic-project-name'}>
            <p className={'result__graphic-legend'}>
              <FormattedMessage id="evaluate.projects"/>
            </p>

            <ul>
              {form.map((item, index) => (
                <li key={index}>
                  <span>{String.fromCharCode('A'.charCodeAt() + index)}</span>{item[0]}<span style={{ color: '#1890ff' }}> {formatter.format(item[1])}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className={'result__graphic-info'}>

            <p className={'result__graphic-legend'}>
              <FormattedMessage id="evaluate.legend"/>
            </p>
            <ul>
              <li> <FormattedMessage id="evaluate.present"/> </li>
              <li> <FormattedMessage id="evaluate.medium"/> </li>
              <li> <FormattedMessage id="evaluate.future"/> </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultEvaluate;
